import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Router, Switch, Route } from 'react-router-dom';
import Introduction from '../Introduction/Introduction';
import Home from '../Home/Home';
import PBPHome from '../PBPHome/PBPHome';
import Navbar from '../../components/Common/Navbar/Navbar';
import Frames from '../../components/Common/Frames/Frames';
import Version from '../../components/Common/Version/Version'; 

import { Paths } from '../../models/Models';

import ScrollToTop from '../../components/Common/ScrollToTop/ScrollToTop';
import PillarsIntro from '../../components/BuildingBrighterFutures/PillarsIntro/PillarsIntro';

import PillarPage from '../../components/BuildingBrighterFutures/PillarPage/PillarPage';
import LandscapeMessage from '../../components/Common/LandscapeMessage/LandscapeMessage';

import VbnIntro from '../../components/VerizonByTheNumbers/VbnIntro/VbnIntro';
import VbnSectionPage from '../../components/VerizonByTheNumbers/VbnSectionPage/VbnSectionPage';

import CcwMain from '../../components/CommunicationsChangeTheWorld/CcwMain/CcwMain';

import CredoMain from '../../components/Credo/CredoMain/CredoMain';

import InnovationMain from '../../components/Innovation/InnovationMain/InnovationMain';

import StoryArchive from '../../components/StoryArchive/StoryArchive';

import { initGA } from '../../store/reducers/gaReducer';


import ReactGA from 'react-ga4';

const ga_data = {
    trackingID: "G-T57S9JLJRB"
};


const Main = ({ version }) => {
    const cms = useSelector(state => state.data.cms);
    const isInitialized = useSelector(state => state.data.initialized);
    const fontsLoaded = useSelector(state => state.data.fontsloaded);
    const ga = useSelector(state => state.ga);
    const dispatch = useDispatch();


    if(!isInitialized || !fontsLoaded || !cms || !ga){
        return null;
    }

    
    if(!ga.history)
        dispatch(initGA(ga_data));
    

    return (
        <>
            {/*<ViewportScaler /> */}
            <Router history={ga.history} basename={'/'}>
            <ScrollToTop />
            <Navbar />
            <div id="main"/>
              <Switch>
                <Route path={`/${cms.digitalMuseum.Path.Text}/:storyId?`} component={Home} />
                <Route path={`/${cms.digitalMuseum.StoryArchive.Menu.Path}/:typeId`} component={StoryArchive} />
                <Route path={`/${cms.poweredByPurpose.Path.Text}/:slideId?`} component={PBPHome} />
                <Route path={`/${cms.buildingBrighterFutures.Path.Text}/${cms.buildingBrighterFutures.Introduction.Menu.Path}`} component={PillarsIntro} />
                <Route path={`/${cms.buildingBrighterFutures.Path.Text}/:pillarId`} component={PillarPage} />
                
                <Route path={`/${cms.verizonByTheNumbers.Path.Text}/${cms.verizonByTheNumbers.Introduction.Menu.Path}`} component={VbnIntro} />
                <Route path={`/${cms.verizonByTheNumbers.Path.Text}/:sectionId`} component={VbnSectionPage} />
                
                <Route path={`/${cms.communicationsChangeTheWorld.Introduction.Menu.Path}`} component={CcwMain} />
                <Route path={`/${cms.credo.Introduction.Menu.Path}`} component={CredoMain} />
                <Route path={`/${cms.innovation.Introduction.Menu.Path}`}>
                    <InnovationMain />
                </Route>
                <Route path={[`/${cms.global.Path.Text}/:introductionId`, `/`]} component={Introduction} />
              </Switch>
            </Router>
            <Frames />
            <LandscapeMessage/>
            <Version number={version} />
        </>
    );
};

export default Main;
